import { type PropsWithChildren, type FunctionComponent } from 'react';
import { FEATURE_FLAGS } from '../../constants/general';
import { useFeature } from '../../hooks/features/features.hooks';

export const StyleLoader: FunctionComponent<PropsWithChildren> = ({ children }) => {
	const luxuryEnabled = useFeature<boolean>(FEATURE_FLAGS.LUXURY_REBRAND, { isSiteWide: true });
	const domainStyle = luxuryEnabled ? 'luxury' : 'base';

	return (
		<div data-testid="style-loader" data-theme={domainStyle}>
			{children}
		</div>
	);
};
